require("./bootstrap");

const setupMarquee = (wrapper) => {
    const track = wrapper.querySelector(".brand-list");
    const baseGroup = track ? track.querySelector(".brand-list2") : null;

    if (!track || !baseGroup || track.dataset.marqueeInitialized === "true") {
        return;
    }

    const wrapperWidth = wrapper.offsetWidth;
    const groupWidth =
        baseGroup.getBoundingClientRect().width || baseGroup.scrollWidth;

    if (!groupWidth) {
        window.requestAnimationFrame(() => setupMarquee(wrapper));
        return;
    }

    let totalWidth = track.scrollWidth;

    while (totalWidth < wrapperWidth * 2) {
        const clone = baseGroup.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        track.appendChild(clone);
        totalWidth = track.scrollWidth;
    }

    track.style.setProperty("--marquee-shift", `${groupWidth}px`);

    const pixelsPerSecond = 120;
    const duration = Math.max(totalWidth / pixelsPerSecond, 12);
    track.style.setProperty("--marquee-duration", `${duration}s`);

    track.dataset.marqueeInitialized = "true";
};

const initMarquees = () => {
    document.querySelectorAll(".brand-list-animation").forEach((wrapper) => {
        setupMarquee(wrapper);
    });
};

document.addEventListener("DOMContentLoaded", () => {
    initMarquees();
    window.addEventListener("load", initMarquees, { once: true });
});
